<div class="modern-admin-page">
  <!-- Page Header -->
  <div class="page-header-card">
    <div class="header-content">
      <div class="page-title-section">
        <h1 class="page-title bangla-heading">দ্রুত SMS পরিষেবা</h1>
        <p class="page-subtitle bangla-text">একাধিক নম্বরে একসাথে SMS পাঠান</p>
      </div>
      <div class="page-actions">
        <span class="info-badge bangla-text" *ngIf="getTotalRecipients() > 0">
          <i class="fas fa-users"></i>
          {{ getTotalRecipients() }} জন প্রাপক
        </span>
        <span class="info-badge bangla-text" *ngIf="message && charCount > 0">
          <i class="fas fa-comment"></i>
          {{ charCount }} অক্ষর ({{ smsCount }} SMS)
        </span>
        <span class="info-badge bangla-text" *ngIf="isDraftMode && currentDraft">
          <i class="fas fa-edit"></i>
          খসড়া: {{ currentDraft.name }}
        </span>
        <span class="info-badge success bangla-text" *ngIf="isAutoSaving">
          <i class="fas fa-save"></i>
          স্বয়ংক্রিয় সংরক্ষণ...
        </span>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <div class="content-grid">
    <!-- SMS Compose Section -->
    <div class="content-card slide-up" id="sms-compose-form" [class.editing-mode]="isDraftMode">
      <div class="card-header">
        <h3 class="card-title bangla-heading">
          <i class="fas fa-paper-plane me-2" *ngIf="!isDraftMode"></i>
          <i class="fas fa-edit me-2" *ngIf="isDraftMode"></i>
          <span *ngIf="!isDraftMode">SMS লিখুন</span>
          <span *ngIf="isDraftMode">খসড়া সম্পাদনা: {{ currentDraft?.name }}</span>
        </h3>
        <div class="card-actions">
          <button class="btn btn-secondary-modern bangla-text" 
                  type="button" 
                  (click)="createNewDraft()"
                  [disabled]="!smsForm.valid">
            <i class="fas fa-save"></i>
            খসড়া হিসেবে সংরক্ষণ
          </button>
          <button class="btn btn-info bangla-text" 
                  type="button" 
                  (click)="previewSMS()"
                  [disabled]="!smsForm.valid">
            <i class="fas fa-eye"></i>
            প্রিভিউ দেখুন
          </button>
          <button class="btn btn-outline-modern bangla-text" 
                  type="button" 
                  *ngIf="isDraftMode"
                  (click)="exitDraftMode()">
            <i class="fas fa-times"></i>
            খসড়া মোড বন্ধ করুন
          </button>
        </div>
      </div>

      <form [formGroup]="smsForm" class="card-body">
        <!-- Recipients Input -->
        <div class="form-row">
          <div class="form-group">
            <label class="form-label bangla-text">প্রাপকদের নম্বর</label>
            <textarea 
              class="form-control" 
              formControlName="recipients"
              rows="3" 
              placeholder="01712345678, 01812345678, 01912345678..."
              [class.is-invalid]="smsForm.get('recipients')?.invalid && smsForm.get('recipients')?.touched">
            </textarea>
            <small class="form-text bangla-text">কমা (,) দিয়ে আলাদা করুন</small>
            
            <!-- Recipients Preview -->
            <div class="recipients-preview mt-2" *ngIf="recipients && recipients.trim().length > 0">
              <div class="alert alert-info">
                <div class="d-flex justify-content-between align-items-center">
                  <span class="bangla-text">
                    <i class="fas fa-users"></i>
                    <strong>{{ getValidRecipients().length }}</strong> টি বৈধ নম্বর পাওয়া গেছে
                    <span *ngIf="getInvalidRecipients().length > 0" class="text-warning">
                      | <strong>{{ getInvalidRecipients().length }}</strong> টি অবৈধ নম্বর
                    </span>
                  </span>
                  <button type="button" 
                          class="btn btn-sm btn-outline-primary bangla-text"
                          (click)="showRecipientsPreview = !showRecipientsPreview">
                    <i class="fas" [class.fa-eye]="!showRecipientsPreview" [class.fa-eye-slash]="showRecipientsPreview"></i>
                    {{ showRecipientsPreview ? 'লুকান' : 'দেখুন' }}
                  </button>
                </div>
                
                <!-- Detailed Recipients View -->
                <div class="recipients-detail mt-3" *ngIf="showRecipientsPreview">
                  <div class="row">
                    <!-- Valid Numbers Column -->
                    <div class="col-md-6" *ngIf="getValidRecipients().length > 0">
                      <h6 class="bangla-text text-success mb-2">
                        <i class="fas fa-check-circle"></i> বৈধ নম্বরসমূহ:
                      </h6>
                      <div class="number-list">
                        <span class="badge bg-success text-white me-1 mb-1" 
                              *ngFor="let number of getValidRecipients()">
                          {{ number }}
                        </span>
                      </div>
                    </div>
                    
                    <!-- Invalid Numbers Column -->
                    <div class="col-md-6" *ngIf="getInvalidRecipients().length > 0">
                      <h6 class="bangla-text text-warning mb-2">
                        <i class="fas fa-exclamation-triangle"></i> অবৈধ নম্বরসমূহ:
                      </h6>
                      <div class="number-list">
                        <span class="badge bg-warning text-dark me-1 mb-1" 
                              *ngFor="let number of getInvalidRecipients()">
                          {{ number }}
                        </span>
                      </div>
                    </div>
                    
                    <!-- When no numbers are entered -->
                    <div class="col-12" *ngIf="getValidRecipients().length === 0 && getInvalidRecipients().length === 0">
                      <p class="bangla-text text-muted text-center">
                        <i class="fas fa-info-circle"></i>
                        কোনো নম্বর পাওয়া যায়নি। দয়া করে প্রাপকদের নম্বর লিখুন।
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="invalid-feedback bangla-text" 
                 *ngIf="smsForm.get('recipients')?.invalid && smsForm.get('recipients')?.touched">
              প্রাপকদের নম্বর আবশ্যক
            </div>
          </div>
        </div>

        <!-- Message Input -->
        <div class="form-row">
          <div class="form-group">
            <label class="form-label bangla-text">SMS বার্তা</label>
            <textarea 
              class="form-control" 
              formControlName="message"
              rows="5" 
              placeholder="আপনার SMS বার্তা এখানে লিখুন..."
              maxlength="1000"
              [class.is-invalid]="smsForm.get('message')?.invalid && smsForm.get('message')?.touched">
            </textarea>
            <div class="character-counter bangla-text">
              {{ charCount }}/1000 অক্ষর | {{ smsCount }} SMS
            </div>
            <div class="invalid-feedback bangla-text" 
                 *ngIf="smsForm.get('message')?.invalid && smsForm.get('message')?.touched">
              SMS বার্তা আবশ্যক
            </div>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="form-actions">
          <button class="btn btn-secondary bangla-text" style="margin-right: 10px;"
                  type="button" 
                  (click)="clearForm()">
            <i class="fas fa-times"></i>
            পরিষ্কার করুন
          </button>
          
          <button class="btn btn-warning bangla-text" style="margin-right: 10px;"
                  type="button" 
                  (click)="updateCurrentDraft()"
                  *ngIf="isDraftMode && currentDraft?.id"
                  [disabled]="!smsForm.valid || !hasFormChanges"
                  [title]="!hasFormChanges ? 'কোনো পরিবর্তন করা হয়নি' : ''">
            <i class="fas fa-sync"></i>
            খসড়া আপডেট করুন
          </button>

          <!-- Show message when no changes detected -->
          <small class="text-muted bangla-text d-block mt-1" 
                 *ngIf="isDraftMode && currentDraft?.id && !hasFormChanges && smsForm.valid">
            <i class="fas fa-info-circle"></i>
            কোনো পরিবর্তন সনাক্ত করা হয়নি
          </small>

          <button class="btn btn-primary-modern bangla-text" 
                  type="button" 
                  (click)="sendSMS()"
                  [disabled]="!smsForm.valid || isLoading || getValidRecipients().length === 0">
            <i class="fas fa-paper-plane" *ngIf="!isLoading"></i>
            <i class="fas fa-spinner fa-spin" *ngIf="isLoading"></i>
            {{ isLoading ? 'পাঠানো হচ্ছে...' : 'SMS পাঠান' }}
          </button>
        </div>
      </form>
    </div>

    <!-- Draft Management Section -->
    <div class="content-card slide-up">
      <div class="card-header">
        <h3 class="card-title bangla-heading">
          <i class="fas fa-drafting-compass me-2"></i>
          সংরক্ষিত খসড়া
        </h3>
        <div class="card-actions">
          <button class="btn btn-sm btn-outline-primary bangla-text" 
                  (click)="toggleFavoritesFilter()"
                  [class.active]="showFavoritesOnly">
            <i class="fas fa-star"></i>
            {{ showFavoritesOnly ? 'সব দেখুন' : 'প্রিয়' }}
          </button>
        </div>
      </div>

      <div class="card-body">
        <!-- Search -->
        <div class="form-row mb-3">
          <div class="form-group">
            <div class="search-input-group">
              <input type="text" 
                     class="form-control" 
                     [(ngModel)]="draftSearchTerm" 
                     (keyup.enter)="searchDrafts()"
                     placeholder="খসড়া খুঁজুন..."
                     style="margin-bottom: 10px;">
              <button class="btn btn-outline-secondary" (click)="searchDrafts()">
                <i class="fas fa-search"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- Loading State -->
        <div class="text-center py-4" *ngIf="isLoadingDrafts">
          <i class="fas fa-spinner fa-spin me-2"></i>
          <span class="bangla-text">লোড হচ্ছে...</span>
        </div>

        <!-- Drafts List -->
        <div class="drafts-list" *ngIf="!isLoadingDrafts">
          <div class="draft-item mb-3 p-3 border rounded" 
               *ngFor="let draft of drafts"
               [class.border-primary]="currentDraft?.id === draft.id"
               [class.bg-light]="currentDraft?.id === draft.id">
            <div class="d-flex justify-content-between align-items-start mb-2">
              <h6 class="draft-title bangla-text mb-0">{{ draft.name }}</h6>
              <div class="draft-actions">
                <button class="btn btn-sm btn-link p-1" 
                        (click)="toggleFavorite(draft)"
                        [class.text-warning]="draft.is_favorite"
                        [class.text-muted]="!draft.is_favorite"
                        title="প্রিয়তে যোগ/সরান">
                  <i class="fas fa-star"></i>
                </button>
                <button class="btn btn-sm btn-link text-danger p-1" 
                        (click)="deleteDraft(draft)"
                        title="মুছে ফেলুন">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
            </div>
            <div class="draft-preview bangla-text text-muted mb-2">
              {{ draft.message.substring(0, 50) }}{{ draft.message.length > 50 ? '...' : '' }}
            </div>
            <div class="draft-meta bangla-text mb-2">
              <small class="text-muted">
                <i class="fas fa-users me-1"></i>
                {{ draft.recipients.split(',').length }} জন প্রাপক
                <span *ngIf="draft.last_used" class="ms-3">
                  <i class="fas fa-clock me-1"></i>
                  {{ draft.last_used | date:'short' }}
                </span>
              </small>
            </div>
            <button class="btn btn-primary-modern bangla-text w-100" 
                    (click)="loadDraft(draft)">
              <i class="fas fa-edit me-1"></i>
              ব্যবহার করুন
            </button>
          </div>

          <!-- Empty State -->
          <div class="text-center py-4" *ngIf="drafts.length === 0">
            <i class="fas fa-inbox text-muted" style="font-size: 3rem;"></i>
            <p class="bangla-text text-muted mt-2">কোনো খসড়া নেই</p>
            <small class="bangla-text text-muted">একটি নতুন খসড়া তৈরি করুন</small>
          </div>

          <!-- Pagination -->
          <div class="d-flex justify-content-between align-items-center mt-3" *ngIf="totalPages > 1">
            <button class="btn btn-sm btn-outline-secondary" 
                    (click)="changePage(currentPage - 1)"
                    [disabled]="currentPage <= 1">
              <i class="fas fa-chevron-left"></i>
            </button>
            <span class="page-info bangla-text">
              {{ currentPage }} / {{ totalPages }}
            </span>
            <button class="btn btn-sm btn-outline-secondary" 
                    (click)="changePage(currentPage + 1)"
                    [disabled]="currentPage >= totalPages">
              <i class="fas fa-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- SMS Statistics Card -->
    <div class="content-card slide-up" *ngIf="smsForm.valid && getValidRecipients().length > 0">
      <div class="card-header">
        <h3 class="card-title bangla-heading">
          <i class="fas fa-chart-line me-2"></i>
          SMS পরিসংখ্যান
        </h3>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-3 col-sm-6 mb-3">
            <div class="stat-card text-center p-3 border rounded">
              <div class="stat-value h4 text-primary mb-1">{{ getValidRecipients().length }}</div>
              <div class="stat-label bangla-text text-muted">বৈধ প্রাপক</div>
            </div>
          </div>
          <div class="col-md-3 col-sm-6 mb-3">
            <div class="stat-card text-center p-3 border rounded">
              <div class="stat-value h4 text-info mb-1">{{ smsCount }}</div>
              <div class="stat-label bangla-text text-muted">SMS প্রতি প্রাপক</div>
            </div>
          </div>
          <div class="col-md-3 col-sm-6 mb-3">
            <div class="stat-card text-center p-3 border rounded">
              <div class="stat-value h4 text-success mb-1">{{ charCount }}</div>
              <div class="stat-label bangla-text text-muted">অক্ষর সংখ্যা</div>
            </div>
          </div>
          <div class="col-md-3 col-sm-6 mb-3">
            <div class="stat-card text-center p-3 border rounded">
              <div class="stat-value h4 text-warning mb-1">{{ getValidRecipients().length * smsCount }}</div>
              <div class="stat-label bangla-text text-muted">মোট SMS</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Draft Save Modal -->
<div class="modal fade" [class.show]="showDraftModal" [style.display]="showDraftModal ? 'block' : 'none'" 
     id="draftSaveModal" tabindex="-1" aria-labelledby="draftSaveModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title bangla-text" id="draftSaveModalLabel">খসড়া সংরক্ষণ করুন</h5>
        <button type="button" class="btn-close" (click)="closeDraftModal()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form #draftForm="ngForm">
          <div class="form-group mb-3">
            <label class="form-label bangla-text">খসড়ার নাম</label>
            <input type="text" 
                   class="form-control" 
                   [(ngModel)]="draftName"
                   name="draftName"
                   placeholder="উদাহরণ: ঈদের শুভেচ্ছা"
                   required>
            <small class="form-text text-muted bangla-text">একটি বর্ণনামূলক নাম দিন যাতে পরে খুঁজে পাওয়া সহজ হয়</small>
          </div>
          <div class="form-group">
            <label class="form-label bangla-text">বার্তার প্রিভিউ</label>
            <div class="alert alert-info">
              <small class="bangla-text">
                <strong>প্রাপক:</strong> {{ getTotalRecipients() }} জন<br>
                <strong>বার্তা:</strong> {{ message.substring(0, 100) }}{{ message.length > 100 ? '...' : '' }}
              </small>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary bangla-text" (click)="closeDraftModal()">
          <i class="fas fa-times"></i>
          বাতিল
        </button>
        <button type="button" class="btn btn-primary bangla-text" 
                (click)="saveDraftWithName()"
                [disabled]="!draftName?.trim()">
          <i class="fas fa-save"></i>
          সংরক্ষণ করুন
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Backdrop -->
<div class="modal-backdrop fade" [class.show]="showDraftModal" 
     [style.display]="showDraftModal ? 'block' : 'none'"></div>

<!-- SMS Preview Modal -->
<div class="modal fade" [class.show]="isPreviewMode" [style.display]="isPreviewMode ? 'block' : 'none'" 
     id="smsPreviewModal" tabindex="-1" aria-labelledby="smsPreviewModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title bangla-text" id="smsPreviewModalLabel">SMS প্রিভিউ</h5>
        <button type="button" class="btn-close" (click)="closePreviewModal()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="sms-preview">
          <div class="alert alert-primary">
            <h6 class="bangla-text mb-3"><i class="fas fa-info-circle"></i> SMS তথ্য</h6>
            <div class="row">
              <div class="col-6">
                <p class="bangla-text mb-2"><strong>প্রাপক:</strong> {{ getTotalRecipients() }} জন</p>
                <p class="bangla-text mb-0"><strong>SMS সংখ্যা:</strong> {{ smsCount }}</p>
              </div>
              <div class="col-6">
                <p class="bangla-text mb-2"><strong>মোট SMS:</strong> {{ getTotalRecipients() * smsCount }}</p>
                <p class="bangla-text mb-0"><strong>অক্ষর:</strong> {{ charCount }}</p>
              </div>
            </div>
          </div>
          <div class="sms-content">
            <h6 class="bangla-text"><i class="fas fa-comment"></i> বার্তা:</h6>
            <div class="card">
              <div class="card-body">
                <div class="message-preview" style="white-space: pre-wrap; font-family: 'SolaimanLipi', sans-serif;">{{ message }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary bangla-text" (click)="closePreviewModal()">
          <i class="fas fa-times"></i>
          বন্ধ করুন
        </button>
        <button type="button" class="btn btn-primary bangla-text" (click)="sendSMS(); closePreviewModal()">
          <i class="fas fa-paper-plane"></i>
          SMS পাঠান
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Backdrop for Preview -->
<div class="modal-backdrop fade" [class.show]="isPreviewMode" 
     [style.display]="isPreviewMode ? 'block' : 'none'"></div>